import { Formik } from "formik";
import { Button, Col, Row } from "reactstrap";
import { useTranslation } from "react-i18next";
import { CustomFormikProps } from "./type";
import { useAppSelector } from "../../store";
import GetInput from "./GetInput";
import Loader from "../Loader";
import MultiLanguageInput from "./MultiLanguageInput";
import React from "react";

const CustomFormik = ({
  inputs,
  multilanguageinputs,
  validationSchema,
  onSubmit,
  onHide,
  loader,
  initialValues,
}: CustomFormikProps) => {
  const { t } = useTranslation();
  const loading = useAppSelector((s) => s.loading.loading);
  return (
    <React.Fragment>
      <Formik
        onSubmit={onSubmit}
        initialValues={initialValues}
        validationSchema={validationSchema}
      >
        {({ values, handleSubmit }) => (
          <div className="m-form">
            {loader && loading && <Loader />}
            <div className="m-form__body">
              <Row style={{ width: "100%", margin: "0px" }}>
                {multilanguageinputs && (
                  <MultiLanguageInput inputKeys={multilanguageinputs} />
                )}
                {inputs &&
                  inputs.map((key, i) => {
                    const disabledvalue = key.onDisabilityChange
                      ? key.onDisabilityChange(values)
                      : false;
                    return key.onHiding && key.onHiding(values) ? (
                      <React.Fragment key={i}></React.Fragment>
                    ) : (
                      <GetInput
                        inputprop={key}
                        key={i}
                        disabledvalue={disabledvalue}
                        overrideOnChange={key.overrideOnChange}
                      />
                    );
                  })}
              </Row>
            </div>

            <div className="m-form__footer">
              {onHide && (
                <Button
                  color="light"
                  type="button"
                  className="m-form__btn"
                  onClick={() => {
                    return onHide();
                  }}
                >
                  {t("FormComponent.Close")}
                </Button>
              )}
              <Button
                color="primary"
                type="submit"
                className="m-form__btn m-form__btn--primary"
                onClick={() => handleSubmit()}
              >
                <i className="mdi mdi-check me-1" />
                {t("FormComponent.Save")}
              </Button>
            </div>
          </div>
        )}
      </Formik>
    </React.Fragment>
  );
};

export default CustomFormik;
